export default __webpack_public_path__ + "static/media/safe.04568c9a.png";